import {BaseEvent} from "./BaseEvent";

export class CreateNewDashboardEvent extends BaseEvent {
  public static NAME = 'createNewDashboard';

  constructor() {
    super(CreateNewDashboardEvent.NAME);
  }
}
